module.exports = __webpack_public_path__ + "img/world.topo.bathy.200401.c29637be.jpg";